import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { StoreDispatch } from '../../Store'

// Components
import AnimateSlideText from '../animation/AnimateSlideText'
import ScrollSection from '../ScrollSection'
import Container from '../Container'
import Grid from '../Grid'
import GridItem from '../GridItem'
import ContainedWrap from '../ContainedWrap'
import RichText from '../RichText'
import Button from '../Button'
import Spacer from '../Spacer'
import AmenitiesItem from '../AmenitiesItem'

// Styles
import { AmenitiesMain, AmenitiesCTA, AmenitiesList } from './index.style'
import { colors } from '../../styles/vars/colors.style'

// Functions
import { scrollToId } from '../../utils/utils'

const AmenitiesCompact = ({
  id,
  heading,
  listItems,
  linkId,
  anchorButtonLabel,
  anchorButtonID,
}) => {
  const dispatch = useContext(StoreDispatch)

  return (
    <ScrollSection id={linkId}>
      <AmenitiesMain>
        <Spacer size={[60, 120]} />

        <Container>
          <Grid>
            <GridItem
              tabletP={8}
              tabletPStart={2}
              tabletL={4}
              tabletLStart={2}
              deskM={3}
              deskMStart={2}
            >
              <ContainedWrap size={350} center={false}>
                <RichText
                  id={`${id}-heading`}
                  content={heading}
                  delayEm={true}
                  forceHeading
                />
                {anchorButtonLabel && anchorButtonID && (
                  <AmenitiesCTA>
                    <Spacer size={[20, 35]} />
                    <AnimateSlideText id={`${id}-anchorlink`}>
                      <Button
                        variant="underline"
                        color={colors.darkBlue}
                        onClick={() => scrollToId(anchorButtonID, dispatch)}
                      >
                        {anchorButtonLabel}
                      </Button>
                    </AnimateSlideText>
                  </AmenitiesCTA>
                )}
              </ContainedWrap>
            </GridItem>

            <GridItem
              tabletP={10}
              tabletPStart={2}
              tabletL={5}
              tabletLStart={7}
              deskM={6}
              deskMStart={6}
            >
              <AmenitiesList>
                <Grid as="ul" tabletP={10} tabletL={5} desk={4} deskM={6}>
                  {React.Children.toArray(
                    listItems?.map((item, itemIndex) => {
                      return (
                        <GridItem as="li" tabletP={5} deskM={3}>
                          <AmenitiesItem
                            as="div"
                            key={itemIndex}
                            id={`${id}-amenity-${itemIndex}`}
                            bottomBorder={false}
                            compact
                            align="left"
                            iconSize="large"
                            {...item}
                          />
                        </GridItem>
                      )
                    })
                  )}
                </Grid>
              </AmenitiesList>
            </GridItem>
          </Grid>
        </Container>

        <Spacer size={[60, 120]} />
      </AmenitiesMain>
    </ScrollSection>
  )
}

AmenitiesCompact.propTypes = {
  id: PropTypes.string.isRequired,
  heading: PropTypes.object,
  text: PropTypes.object,
  disclaimer: PropTypes.string,
  listItems: PropTypes.array,
  linkId: PropTypes.string,
}

export default AmenitiesCompact
